module.exports = __webpack_public_path__ + "img/ziraat.4ce0620d.png";